import {
  PaymentAccountReferenceV1,
  PaymentRequestV1PaymentMethod,
  PaymentReferenceV1,
  PaymentRequestV1,
  PositiveAmount,
  RequestedExecutionOptionsV1,
  RequestedPaymentIdentifiersV1,
} from "../generated";

export class PaymentRequest implements PaymentRequestV1 {
  amount: Amount;
  destination: PaymentAccountReferenceV1;
  execution?: RequestedExecutionOptionsV1;
  identifiers?: RequestedPaymentIdentifiersV1;
  transactionText?: string;
  message?: string;
  endToEndId?: string;
  paymentMethod: PaymentRequestV1PaymentMethod;
  reference?: PaymentReference;
  sourceAccountId?: string;

  constructor() {
    this.amount = new Amount();
    this.destination = {};
    this.execution = {
      type: "Normal",
    };
    this.identifiers = {};
  }
}

class Amount implements PositiveAmount {
  value: number;
  currency: string;

  constructor() {
    this.value = 1;
  }
}

class PaymentReference implements PaymentReferenceV1 {
  value: string;
}
